{
  "gps": {
    "title": "Rastreamento GPS",
    "liveTracking": "Rastreamento em Tempo Real",
    "geofences": "Geocercas",
    "reports": "Relatórios",
    "alerts": "Alertas",
    "soon": "Breve",
    "comingSoon": "Em Breve",
    "reportsComingSoon": "Relatórios em Breve",
    "reportsComingSoonMessage": "Estamos a trabalhar em relatórios de viagens, histórico de rotas e análises. Fique atento!",
    "alertsComingSoon": "Alertas em Breve",
    "alertsComingSoonMessage": "Alertas e notificações em tempo real estarão disponíveis em breve.",
    "geofencesComingSoon": "Geocercas em Breve",
    "geofencesComingSoonMessage": "Crie e gira limites geográficos para os seus veículos.",
    
    "device": "Dispositivo",
    "devices": "Dispositivos",
    "devicesCount": "Dispositivos ({{count}})",
    "online": "Online",
    "offline": "Offline",
    "noLocationData": "Sem dados de localização",
    "speed": "Velocidade",
    "course": "Rumo",
    "lastUpdate": "Última Actualização",
    "lastUpdated": "Última actualização",
    "coordinates": "Coordenadas",
    "deviceInfo": "Informações do Dispositivo",
    "imei": "IMEI",
    "makeModel": "Marca/Modelo",
    "noData": "Sem dados",
    "locationData": "Dados de Localização",
    
    "vehicle": "Veículo",
    "driver": "Motorista",
    "registration": "Matrícula",
    
    "geofence": "Geocerca",
    "createGeofence": "Criar Geocerca",
    "editGeofence": "Editar Geocerca",
    "deleteGeofence": "Eliminar Geocerca",
    "geofenceName": "Nome da Geocerca",
    "description": "Descrição",
    "color": "Cor",
    "active": "Activa",
    "inactive": "Inactiva",
    "polygon": "Polígono",
    "circle": "Círculo",
    
    "trip": "Viagem",
    "trips": "Viagens",
    "route": "Rota",
    "routes": "Rotas",
    "summary": "Resumo",
    "generateReport": "Gerar Relatório",
    "selectDateRange": "Seleccionar Período",
    "selectDevice": "Seleccionar Dispositivo",
    "distance": "Distância",
    "duration": "Duração",
    "averageSpeed": "Velocidade Média",
    "maxSpeed": "Velocidade Máxima",
    "startLocation": "Local de Início",
    "endLocation": "Local de Fim",
    "engineHours": "Horas de Motor",
    
    "alert": "Alerta",
    "alertType": "Tipo de Alerta",
    "acknowledge": "Reconhecer",
    "acknowledged": "Reconhecido",
    "unacknowledged": "Não Reconhecido",
    "allAlerts": "Todos os Alertas",
    
    "geofenceEnter": "Entrada em Geocerca",
    "geofenceExit": "Saída de Geocerca",
    "speedExceeded": "Velocidade Excedida",
    "deviceOffline": "Dispositivo Offline",
    "deviceOnline": "Dispositivo Online",
    "ignitionOn": "Ignição Ligada",
    "ignitionOff": "Ignição Desligada",
    "lowBattery": "Bateria Baixa",
    "sosAlarm": "Alarme SOS",
    
    "noLicense": "Sem Licença GPS",
    "noLicenseTitle": "Rastreamento GPS Não Disponível",
    "noLicenseMessage": "A sua empresa não possui licenças GPS activas.",
    "noLicenseAction": "Por favor, adquira licenças GPS para aceder aos recursos de rastreamento em tempo real.",
    "viewPlans": "Ver Planos",
    "upgradeToPro": "Actualizar para Rastreamento GPS",
    "checkingAccess": "A verificar acesso GPS...",
    
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "connecting": "A conectar",
    "reconnecting": "A reconectar",
    
    "searchDevices": "Pesquisar dispositivos, matrículas, marca/modelo...",
    "noDevicesFound": "Nenhum dispositivo encontrado",
    "tryDifferentSearch": "Tente um termo de pesquisa diferente",
    "searchVehicles": "Pesquisar veículos por matrícula, marca, modelo...",
    "noVehiclesFound": "Nenhum veículo encontrado",
    
    "noDevices": "Nenhum Dispositivo GPS Activo",
    "noDevicesMessage": "Os dispositivos aparecerão aqui quando começarem a reportar posições",
    "noGeofences": "Nenhuma Geocerca Criada",
    "noGeofencesMessage": "Toque em 'Criar' para adicionar a sua primeira geocerca",
    "noReports": "Nenhum Relatório Gerado",
    "noReportsMessage": "Seleccione um período e gere um relatório para ver os dados aqui",
    "noAlerts": "Nenhum Alerta",
    "noPendingAlerts": "Nenhum Alerta Pendente",
    "allAlertsAcknowledged": "Todos os alertas foram reconhecidos",
    
    "loading": "A carregar",
    "loadingGeofences": "A carregar geocercas...",
    "refreshing": "A actualizar",
    "syncing": "A sincronizar",
    "error": "Erro",
    "success": "Sucesso",
    "create": "Criar",
    "edit": "Editar",
    "delete": "Eliminar",
    "save": "Guardar",
    "cancel": "Cancelar",
    "close": "Fechar",
    "refresh": "Actualizar",
    "filter": "Filtrar",
    
    "drawInstructions": "Toque no mapa para adicionar pontos ao seu polígono",
    "drawingMode": "Modo de Desenho",
    "completePolygon": "Completar Polígono",
    "cancelDrawing": "Cancelar",
    "minimumPoints": "Um polígono deve ter pelo menos 3 pontos",
    
    "geofenceCreated": "Geocerca criada com sucesso",
    "geofenceUpdated": "Geocerca actualizada com sucesso",
    "geofenceDeleted": "Geocerca eliminada com sucesso",
    "confirmDelete": "Tem a certeza de que deseja eliminar esta geocerca?",
    
    "reportGenerated": "Relatório gerado com sucesso",
    "exportPDF": "Exportar para PDF",
    "exportCSV": "Exportar para CSV",
    
    "alertAcknowledged": "Alerta reconhecido com sucesso",
    "managedInAdmin": "As regras de alerta são geridas no painel de administração do Django",
    
    "selectVehicle": "Selecionar Veículo",
    "noVehicleAssigned": "Sem veículo atribuído",
    "noVehicleLinked": "Nenhum veículo associado a este dispositivo",
    "vehicleAssigned": "Veículo atribuído com sucesso",
    "vehicleUnassigned": "Veículo removido com sucesso",
    "failedToAssignVehicle": "Falha ao atribuir veículo",
    "failedToUnassignVehicle": "Falha ao remover veículo",
    "failedToLoadVehicles": "Falha ao carregar veículos",
    "unassignVehicle": "Remover Veículo",
    "noVehiclesAvailable": "Sem veículos disponíveis",
    "linkToVehicle": "Associar a Veículo",
    "linkVehicle": "Associar Veículo",
    "editVehicle": "Editar Veículo",
    "deviceNotFound": "Dispositivo não encontrado",
    "forceUpdate": "Forçar Actualização",
    "updating": "A actualizar...",
    "forceUpdateNote": "Sincroniza dados do dispositivo com o servidor",
    "deviceDataUpdated": "Dados do dispositivo actualizados com sucesso",
    "failedToUpdateDevice": "Falha ao actualizar dados do dispositivo",
    "vehicles": "Veículos",
    "loadingVehicles": "A carregar veículos...",
    "updatedAt": "Actualizado",
    "contractTitle": "Contrato de Utilização GPS",
    "contractSummary": "Ao aceitar, concorda com os termos de utilização do rastreamento GPS (recolha de dados, responsabilidades e privacidade) conforme documentação legal.",
    "contractAccept": "Aceitar",
    "contractReject": "Cancelar",
    "contractAccepting": "A aceitar...",
    "contractAcceptError": "Falha ao aceitar o contrato.",
    "contractVersion": "Versão {{version}}, de {{date}}",
    "contractSummaryHeading": "Resumo pré-aceitação",
    "contractFullHeading": "Contrato completo e Anexo A",
    "contractCopyRecipient": "A cópia do contrato em PDF será enviada para {{email}} depois de a Stripe confirmar o pagamento."
  }
}

